<template>
	<div>

		<section id="home" class="video-hero home-top">
			<div class="overlay top-bk">
			</div>
			<div class="display-t text-center mt-5 mt-md-0">
				<div class="display-tc">
					<div class="container">
						<div class="col-md-12 col-md-offset-0">

              <div class="animate-box main-top-area">
                <div class="d-flex row">
                  <!-- <div v-html="$t('site.home.subtitle')" class="col-md-6"></div> -->
                  <div class="col-md-6 pt-5 pt-md-0 d-flex align-items-center">
                    <div>
                      <h3 class="text-light text-left">
                        {{ $t('site.recruitment.title') }}
                      </h3>

                      <div
												class="mt-3 text-white img-mobile  text-left"
                        v-html="$t('site.recruitment.subtitle')"
                      ></div>
                    </div>
                  </div>
                  <div class="col-md-6">
										<img 
											src="@/assets/img/profiles.png" 
											class="img-mobile"
										>
                  </div>
                </div>
                <p>
                  <router-link
                    :to="{ name: 'create_account' }"
                    class="btn mt-4 mb-4 btn-primary btn-lg btn-custom"
                  >
                    <i class="icon-plus2"></i>
                    {{ $t("site.register.btn_create_your_account") }}
                  </router-link>
                </p>
              </div>

							<!-- <div class="row">
								<div class="animate-box main-top-area col-md-6 text-left pt-sm-3">
									<h2 v-html="$t('site.recruitment.title')" class="text-shadow">
									</h2>
									<div v-html="$t('site.recruitment.subtitle')" class="text-white"></div>
									<p>
										<router-link 
											:to="{ name: 'create_account'}" 
											class="btn btn-sm mt-4 mb-4 btn-primary btn-lg btn-custom"
										>
											<i class="icon-plus2"></i>
											{{ $t('site.register.btn_create_your_account') }}
										</router-link>
									</p>
								</div>

								<div class="col-md-6 d-flex justify-content-center align-items-center">
									<img 
										src="@/assets/img/profiles.png" 
										alt="Quotation"
										class="img-drawing"
										widht="100%"
									>

								</div>

							</div> -->

						</div>
					</div>
				</div>
			</div>
		</section>
		<!-- <div class="pb-1">
			<carousel :autoplay="true" :nav="false"  :items="1" wid class="carousel-top">

					<img src="@/assets/img/screen-dashboard.jpg">
					<img src="@/assets/img/screen-process-form.jpg">
					<img src="@/assets/img/screen-process-kanban.jpg">
					<img src="@/assets/img/screen-profile.jpg">
					<img src="@/assets/img/screen-profile-2.jpg">
					<img src="@/assets/img/screen-financial-extract-1.jpg">

			</carousel>
		</div> -->
		<div class="colorlib-services colorlib-bg-white_ mt-3">
			<div class="container">
				<div class="row pt-sm-4">
					<div class="col-md-4 text-center animate-box">
						<div class="services">
							<span class="icon">
								<i class="icon-browser"></i>
							</span>
							<div class="desc">
								<h2>{{ $tc('recruitment', 1) }}</h2>
								<div v-html="$t('site.home.features.process.desc')"></div>
							</div>
						</div>
					</div>
					<div class="col-md-4 text-center animate-box">
						<div class="services">
							<span class="icon">
								<i class="icon-download"></i>
							</span>
							<div class="desc">
								<h2>{{ $tc('profile_bank', 2) }}</h2>
								<div v-html="$t('site.home.features.profile_and_cvs.desc')"></div>
							</div>
						</div>
					</div>
					<div class="col-md-4 text-center animate-box">
						<div class="services">
							<span class="icon">
								<i class="icon-lightbulb"></i>
							</span>
							<div class="desc">
								<h2>{{ $tc('custom_features', 2) }}</h2>
								<div v-html="$t('site.home.features.custom_features.desc')"></div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- <div class="colorlib-intro">
			<div class="container">
				<div class="row">
					<div class="col-md-8 col-md-offset-2 text-center colorlib-heading animate-box">
						<h2>Collaborate with your design team in a new way</h2>
						<p>Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small line of blind text by the name of Lorem Ipsum decided to leave for the far World of Grammar.</p>
					</div>
				</div>
				<div class="row">
					<div class="col-md-12 animate-box">
						<span class="play"><a href="https://vimeo.com/channels/staffpicks/93951774" class="pulse popup-vimeo"><i class="icon-play3"></i></a></span>
					</div>
				</div>
			</div>
		</div> -->

		<div 
			id="colorlib-counter"
			class="colorlib-counters" 
		>
			<div class="overlay"></div>
			<div class="container">
				<div class="row">
					<div class="col-md-4 col-sm-4 text-center animate-box">
						<div class="counter-entry">
							<span class="icon"><i class="flaticon-ribbon"></i></span>
							<div class="desc">
								<span class="colorlib-counter js-counter" data-from="0" data-to="1500" data-speed="5000" data-refresh-interval="50"></span>
								<span class="colorlib-counter-label">
									{{ $tc('online_system', 1) }}
								</span>
							</div>
						</div>
					</div>
					<div class="col-md-4 col-sm-4 text-center animate-box">
						<div class="counter-entry">
							<span class="icon"><i class="flaticon-church"></i></span>
							<div class="desc">
								<span class="colorlib-counter js-counter" data-from="0" data-to="500" data-speed="5000" data-refresh-interval="50"></span>
								<span class="colorlib-counter-label">
									{{ $t('process_and_profile_configurator') }}	
								</span>
							</div>
						</div>
					</div>
					<div class="col-md-4 col-sm-4 text-center animate-box">
						<div class="counter-entry">
							<span class="icon"><i class="flaticon-dove"></i></span>
							<div class="desc">
								<span class="colorlib-counter js-counter" data-from="0" data-to="1200" data-speed="5000" data-refresh-interval="50"></span>
								<span class="colorlib-counter-label">
									{{ $t('free_support_and_training') }}
								</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="colorlib-work-featured colorlib-bg-white">
			<div class="container">
				<div class="row mobile-wrap">
					<div class="col-md-7 animate-box">
						<img src="@/assets/img/profile_compare.jpg" width="100%">
					</div>
					<div class="col-md-5 animate-box">
						<div class="desc">
							<h2>
								{{ $tc('compare_profile.label', 2) }}
							</h2>
							<div class="features">
								<!-- <span class="icon"><i class="icon-lightbulb"></i></span> -->
								<div class="f-desc_">
									<p class="mt-2">
										{{ $t('compare_profile.desc') }}
									</p>
								</div>
							</div>
							<!-- <div class="features">
								<span class="icon"><i class="icon-circle-compass"></i></span>
								<div class="f-desc">
									<p>Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small line of blind text by the name</p>
								</div>
							</div>
							<div class="features">
								<span class="icon"><i class="icon-beaker"></i></span>
								<div class="f-desc">
									<p>Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small line of blind text by the name of Lorem Ipsum decided to leave for the far World of Grammar.</p>
								</div>
							</div> -->
								<router-link :to="{name: 'create_account'}" class="btn btn-primary btn-outline with-arrow">
									{{ $t('action.create_free_account') }}
									<i class="icon-arrow-right3"></i>
								</router-link>
						</div>
					</div>
				</div>
				<div class="row mobile-wrap">
					<div class="col-md-5 animate-box">
						<div class="desc">
							<h2>{{ $tc('profile_status.label', 2) }}</h2>
							<div class="features">
								<!-- <span class="icon"><i class="icon-lightbulb"></i></span> -->
								<div class="f-desc_">
									<p class="mt-2">
										{{ $t('profile_status.desc') }}	
									</p>
								</div>
							</div>
							<!-- <div class="features">
								<span class="icon"><i class="icon-circle-compass"></i></span>
								<div class="f-desc">
									<p>Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small line of blind text by the name</p>
								</div>
							</div>
							<div class="features">
								<span class="icon"><i class="icon-beaker"></i></span>
								<div class="f-desc">
									<p>Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life One day however a small line of blind text by the name of Lorem Ipsum decided to leave for the far World of Grammar.</p>
								</div>
							</div> -->
							<p>
								<router-link :to="{name: 'create_account'}" class="btn btn-primary btn-outline with-arrow">
									{{ $t('action.create_free_account') }}
									<i class="icon-arrow-right3"></i>
								</router-link>
							</p>
						</div>
					</div>
					<div class="col-md-7 animate-box">
						<img src="@/assets/img/profile_status.jpg" width="100%">
					</div>
				</div>
			</div>
		</div>
		<PlansBoxs :is-main="false" class="mt-5"/>

	</div>
</template>

<script>
// import carousel from 'vue-owl-carousel'
import PlansBoxs from "@/components/pages/Plans/PlansBoxs";

export default {
	name: "AppTemplate",
	components: {
		// carousel,
		PlansBoxs,
	},
  computed: {
    selectedCategoryId() {
      return this.filters.category_id;
    }
  },
  mounted() {
		// this.$helpers.ga.openPage('home');
		this.$helpers.scrollTop(0);
  },
  methods: {
    changeCategory(id) {
      this.setFilterCategoryId({ id: id });
      console.log(id);
    }
  }
};
</script>

<style lang="scss">
@import 'src/assets/css/patterns.scss';


	.img-drawing {
		@media screen and (max-width: $screen-sm) {
			max-width: 300px;
		}
	}

	.display-tc-min {
		
		&.display-tc {
			
			@media screen and (min-width: 769px) {
				height: fit-content !important;
				padding-top: 150px;
			}
		}

		.img-banner {
			img {
				@media screen and (max-width: $screen-sm) {
					width: 300px;
				}
			}
		}

	}

	.text-shadow {
		text-shadow: 0px 1px 0px rgba(80, 80, 80, 1);
	}

	.animate-box.main-top-area {
		h2, h1 {
			color: white;
		}
		p {
			font-size: 20px !important;
		}
	}

	.carousel-top {
		margin: 0 auto;
		margin-bottom: 20px;
		/* display: flex; */
		max-width: 1260px;
		margin-top: -50px;
		margin-top: -0em !important;

		.owl-carousel .owl-stage-outer {
			-webkit-box-shadow: 0px 9px 24px 1px rgba(0,0,0,0.37);
			-moz-box-shadow: 0px 9px 24px 1px rgba(0,0,0,0.37);
			box-shadow: 0px 9px 24px 1px rgba(0,0,0,0.37);
		}

		@media screen and (min-width: 769px) {
			margin-top: -10em !important;
		}

	}

	.player {
		opacity: 0.06;
	}

	.video-hero.home-top, .player {
		height: 700px !important;

    @media screen and (max-width: 769px){
      height: 750px !important;
    }

		.overlay.top-bk {
			// border: 1px solid red;
			// background-image: url(/assets/images/cover_img_1.jpg) !important;  
			background-size:cover; 
			background-position: center center;
			background-attachment:fixed;
		}
	} 
</style>